import { exists } from '../../base/dom-utils.js';
import Form from '../base/form.js';
import Spinner from './spinner.js';
import UserHandler from '../base/user.js';
import { UserHandler as SessionUserHandler, getLocalStorage, getSessionStorage } from '../../base/session-handler.js';
import { FTSI, OKTA_ID, requestUrls, MFA_PHONE_NUMBER_NEW } from '../../base/vars.js';
import { isValidOktaPassword, mapBusinessTravelerType, mapPhoneTypeCode, CookieHandler, getJsonObject } from '../../base/utils.js';
import Login from './login.js';
import PhoneInput from './phone-input';

window.onpageshow = function(event) {
  if (event.persisted) {
    window.location.reload(true);
  }
};

class MyProfileForm {
  constructor() {
    this.formSelector = '#profileUpdate',
    this.$form = $(this.formSelector);
    $('#phoneType0').prop("disabled", true);
    //businessEnrollment el
    this.$beCheckbox = null;
    this.$beSelect = null;
    if (this.$form.length > 0) {
      this.onUserUpdated();
      this.showPasswordRequirements();
      this.initPasswordMatcher();
    }
    if ($('.my-profile-template').length > 0) {
      $(document).one('user:profile:updated', () => {
        Spinner.remove('body');
      });
    }
    $("#emailAddress").on("keyup",function(){
      var label = $("label[for='emailAddress']"); 
      $('#email-error-message').css('display', 'none');
      label.css('color', '#666666');
    });
    [$('.verify-email')].forEach(emailMessage => {
      emailMessage.addClass('hidden');
    });
    [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
      emailMessage.addClass('hidden');
    });
    [$('.verificationMessage'), $('.resendEmail')].forEach(emailMessage => {
      emailMessage.addClass('hidden');
    });
    const emailSent = localStorage.getItem('EMAIL_SENT_NOT_VERIFY') ? localStorage.getItem('EMAIL_SENT_NOT_VERIFY') : false;
    console.log('emailSent', emailSent);
  }

  addEventListeners() {
    this.$form.on('change', '#phoneNumber0', (event) => {
        this.$form.formValidation('revalidateField', $(event.target));  
    });
  }

  onUserUpdated() {
    $(document).one('user:profile:updated', () => {
      this.formInit();
      this.initPhoneInputField();
      this.onAddPhoneClick();
      this.onAddAddressClick();
      this.onPrimaryCheckboxChange();
      this.onAddressTypeChange();
      this.initBusinessEnrollmentListener();
      this.initUsername();
      this.initViewPassword();
      Form.onCountryChange();
      Form.showAdditionalAddresses($('#profileUpdate'));

    });

    $(document).on('user:profile:updated', () => {
      this.showAdditionalPhoneNumbers();
      this.initResendEmail();
      Form.checkPrimaryCheckbox();
      Form.displayBusinessName();
      Form.displayLockedMemberName();
      Form.displayLockedCountry();
      Form.enableZipCodeValidation($('#profileUpdate'));
      this.checkBusinessEnrollmentState();
      Form.disableFormField(this.$form.find('.submit'));

      this.email = $('#emailAddress').val();
    });
  }

  initPhoneInputField() {
    PhoneInput.initializePhoneInputs();
    let phoneNumber = $('#phoneNumber0').val();
    if (phoneNumber && phoneNumber.startsWith('+')) {
      PhoneInput.refreshInputField(0);
      const countryCode = PhoneInput.getPhoneNumberCountryByIndex(0);
      const newPhoneNumber = phoneNumber.replace(countryCode, '');
      if(newPhoneNumber !== phoneNumber) {
        $('#phoneNumber0').val(newPhoneNumber);
      }
    }
  }

  onAddPhoneClick() {
    $(document).on('click', '.add-phone-btn', (e) => {
      $('#profileUpdate .flex-form-group').children('.phone-fieldset.hidden')
        .first()
        .removeClass('hidden');
      if ($('#profileUpdate .phone-fieldset.hidden').length == 0) {
        $(e.currentTarget).hide();
      }
    });
  }

  onAddAddressClick() {
    $(document).on('click', '.add-address-btn', (e) => {
      $('#profileUpdate .flex-form-group').children('.address-group.hidden')
        .removeClass('hidden');
      if ($('#profileUpdate .address-group.hidden').length == 0) {
        $(e.currentTarget).hide();
      }
      $('.primary-checkbox').find('input[type="checkbox"]')
        .attr('disabled', false);
      Form.changeAddressType($('#addressType0'));
      Form.displayCorrectStates($('#state1'), $(e.currentTarget));
      $('#profileUpdate').formValidation('enableFieldValidators', 'country1', true);
    });
  }

  onPrimaryCheckboxChange() {
    $(document).on('click', '.primary-checkbox input:checkbox', (e) => {
      if ($(e.currentTarget).is(':checked')) {
        $('.primary-checkbox input:checkbox').not($(e.currentTarget))
          .prop('checked', false);
      } else {
        $('.primary-checkbox input:checkbox').not($(e.currentTarget))
          .prop('checked', true);
      }
    });
  }

  onAddressTypeChange() {
    $(document).on('change', '#addressType0, #addressType1', (e) => {
      Form.changeAddressType($(e.currentTarget));
      Form.displayBusinessName();
    });
  }


  showAdditionalPhoneNumbers() {
    let phoneNumbers = window.User.phones,
      $hiddenNumbers = $('.phone-fieldset.hidden'),
      $visibleNumbers = $('.phone-fieldset:not(.hidden)');

    if (phoneNumbers) {
      if (phoneNumbers.length > 2) {
        $hiddenNumbers.removeClass('hidden');
        $('.add-phone-btn').hide();
      } else if ($visibleNumbers.length < phoneNumbers.length) {
        $hiddenNumbers.first().removeClass('hidden');
      }
    }
  }

  initBusinessEnrollmentListener() {
    this.$beCheckbox = $('#businessEnrollmentCheckbox');
    this.$beSelect = $('#businessEnrollmentSelect');
    if (this.$beCheckbox.length > 0) {
      //Add listener
      $(document).on('change', '#businessEnrollmentCheckbox', (e) => {
        if (this.$beCheckbox.is(':checked')) {
          Form.toggleBussinessEnrollmentDropdown(this.$beCheckbox);
        } else {
          this.$form.formValidation('revalidateField', this.$beSelect);
          Form.toggleBussinessEnrollmentDropdown(this.$beCheckbox);
        }
      });
      //Reset on cancel button
      $(document).on('click', 'button.cancel', () => {
        Form.toggleBussinessEnrollmentDropdown(this.$beCheckbox);
      });
    }
  }

  checkBusinessEnrollmentState() {
    if (this.$beCheckbox.length > 0) {
      Form.toggleBussinessEnrollmentDropdown(this.$beCheckbox);
    }
  }

  // ----- FORM VALIDATION LOGIC -----
  formInit() {
    if (exists($('form#profileUpdate + .submit'))) {
      $('form#profileUpdate + .submit').addClass('submit-profile');
      $('form#profileUpdate').append($('form#profileUpdate + .submit'));
    }
   
    
    this.$form
      .on('init.form.fv', (e) => {
        Form.removeFormError($(e.target));
      })
      .formValidation({
        button: {
          selector: '.submit-profile',
          disabled: ''
        },
       live: 'enabled',
        fields: {
          'currentPassword': {
            excluded: true
          },
          'password': {
            excluded: true
          },
          'confirmPassword': {
            excluded: true
          },
          'emailAddress': {
            validators: {
              regexp: {
                regexp: /^(?!\.)((?!.*\.{2})[a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\.!#$%&'*+-/=?^_`{|}~\-\d]+)@(?!\.)([a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\-\.\d]+)((\.([a-zA-Z\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF]){2,63})+)$/,
                message: $('#emailAddress ~ .error-msg-two') && $('#emailAddress ~ .error-msg-two').text()
              },
              notEmpty: {
                enabled: true,
                message: $('#emailAddress ~ .error-msg-two') && $('#emailAddress ~ .error-msg-two').text()
              },
              stringLength: {
                min: 6,
                max: 128,
                message: $('#emailAddress ~ .error-msg-two') && $('#emailAddress ~ .error-msg-two').text()
              },
            }
          },
          'primaryCheckbox': {},
          'birthMonth': {},
          'birthDay': {},
          'birthYear': {},
          'phoneNumber0': {
            validators: {
              callback: {
                callback: (value, validator, $field) => {
                 if($field[0] === document.activeElement) return true;
                  const isValid = this.phoneNumberValidation(value, validator, $field, 0);
                  if (isValid) {
                    const updatedPhonNumber = PhoneInput.getPhoneNumberWithCountryCode(value, 0);
                    CookieHandler.createCookie(MFA_PHONE_NUMBER_NEW, updatedPhonNumber, 1);
                  }
                  const savePhoneButton = $('.verification-buttons .btn-primary');
                  if (savePhoneButton) {
                    savePhoneButton.attr('disabled', !isValid.valid);
                  }
                  return isValid;
                }
              },
              notEmpty: {
                enabled: true
              }
            }
          },
          'phoneType0': {
            validators: {
              callback: {
                callback: (value, validator, $field) => this.phoneTypeValidator(value, validator, $field)
              }
            }
          },
          'phoneNumber1': {
            validators: {
              callback: {
                callback: (value, validator, $field) => this.phoneNumberValidation(value, validator, $field, 1)
              },
              notEmpty: {
                enabled: true
              }
            }
          },
          'phoneType1': {
            validators: {
              callback: {
                callback: (value, validator, $field) => this.phoneTypeValidator(value, validator, $field)
              }
            }
          },
          'phoneNumber2': {
            validators: {
              callback: {
                callback: (value, validator, $field) => this.phoneNumberValidation(value, validator, $field, 2)
              },
              notEmpty: {
                enabled: true
              }
            }
          },
          'phoneType2': {
            validators: {
              callback: {
                callback: (value, validator, $field) => this.phoneTypeValidator(value, validator, $field)
              }
            }
          },
          'addressType0': {
            validators: {
              notEmpty: {
                enabled: true
              }
            }
          },
          'addressType1': {
            validators: {
              notEmpty: {
                enabled: true
              }
            }
          },
          'address1-0': {
            validators: {
              stringLength: {
                max: 200
              }
            }
          },
          'address2-0': {
            validators: {
              stringLength: {
                max: 200
              }
            }
          },
          'address3-0': {
            validators: {
              stringLength: {
                max: 200
              }
            }
          },
          'address1-1': {
            validators: {
              stringLength: {
                max: 200
              }
            }
          },
          'address2-1': {
            validators: {
              stringLength: {
                max: 200
              }
            }
          },
          'address3-1': {
            validators: {
              stringLength: {
                max: 200
              }
            }
          },
          'city0': {
            validators: {
              stringLength: {
                max: 100
              }
            }
          },
          'city1': {
            validators: {
              stringLength: {
                max: 100
              }
            }
          },
          'state0': {},
          'state1': {},
          'country0': {
            validators: {
              notEmpty: {
                enabled: true
              }
            }
          },
          'country1': {
            enabled: false,
            validators: {
              notEmpty: {
                enabled: true
              }
            }
          },
          'zipCode0': {
            enabled: false,
            validators: {
              stringLength: {
                min: 5,
                max: 12
              },
              notEmpty: {
                enabled: true
              }
            }
          },
          'zipCode1': {
            enabled: false,
            validators: {
              stringLength: {
                min: 5,
                max: 12
              },
              notEmpty: {
                enabled: true
              }
            }
          },
          'businessEnrollmentCheckbox':{},
          'businessEnrollmentSelect': {
            trigger: 'blur change',
            message: $('.business-enrollment-wrapper .select-container').length > 0 ? $('.business-enrollment-wrapper .select-container').data('errorMsg') : 'This field is required',
            validators: {
              callback: {
                callback: (value, validator, $field) => this.businessEnrollmentValidation(value, validator, $field)
              }
            }
          }
        }
      })
      .on('success.form.fv', (e) => {
        e.preventDefault();
        this.$form.formValidation('revalidateField', this.$beSelect);
        if (this.$form.data('formValidation').isValid()) {
          let data = this.createFormData();
          const user = SessionUserHandler.getOktaUser();
          if (user && user.email && user.email.toLowerCase() !== $('#emailAddress').val().toLowerCase()) {
            this.updateEmail($('#emailAddress').val());
          }
          this.postForm(data);
        }
      })
      .on('err.field.fv', Form.handleMultipleErrorLabels);

    this.addEventListeners();
  }

  businessEnrollmentValidation(value, validator, $field) {
    if (value) {
      return true;
    }
    let $beCheckbox = $field.closest('.business-enrollment-wrapper').find('#businessEnrollmentCheckbox');
    return !$beCheckbox.is(':checked');
  }

  // Created custom validator because the built-in 'different'
  // validator wasn't working with multiple fields
  phoneTypeValidator(value, validator, $field) {
    let $activeFields = this.$form.find('[name*="phoneType"]:visible');

    let match = _.find($activeFields.not($field), el => $(el).val() === value);

    // After initial submission attempt errors need to be handled on change
    // to match the current validation behavior
    _.once(() => this.initPhoneTypeChangeHandler());

    return !match;
  }

  initPhoneTypeChangeHandler() {
    let $phoneTypeFields = this.$form.find('[name*="phoneType"]');
    $phoneTypeFields.change(e => {
      let $changedField = $(e.currentTarget);
      let $activeFields = $phoneTypeFields.filter(':visible');
      _.each($activeFields.not($changedField), el => {
        this.$form.formValidation('revalidateField', $(el));
      });
    });
  }

  phoneNumberValidation(value, validator, $field, index) {
    const countryCode = PhoneInput.getPhoneNumberCountryByIndex(index);
    let newPhoneNumber = value;
    if (countryCode && newPhoneNumber.startsWith(countryCode)) {
      newPhoneNumber = newPhoneNumber.slice(countryCode.length);
    }
    const parsed = newPhoneNumber.match(/(\d)/g);

    const valid = !(!/^\+?[\d\s\-\(\)\.]*$/i.test(value) || (parsed && (parsed.length < 8 || parsed.length > 18)));
    return {
      valid
    };
  }

  // ----- FORM SUBMISSION LOGIC ------
  createFormData() {
    let data = window.User,
      inputs = _.union(
        _.toArray($('.phone-fieldset').find('input, select')),
        _.toArray($($('.address-group')[0]).find('input, select')),
        _.toArray($('#isoDateOfBirth')),
        _.toArray($('#plo')),
        _.toArray($('#emailAddress'))
      );

    // instantiate update flags
    data = {
      ...data,
      updateCustomer: true,
      updateAddress: false,
      updateAlias: false,
      updatePreferences: false,
      updateEmail: false,
    };

    // rename accountNumber to memberIdentifier
    data.memberIdentifier = data.accountNumber;
    delete data.accountNumber;

    $.each(inputs, (i, e) => {
      if($(e).attr('id').includes('phoneType')) {
        const phoneOrder = parseInt($(e).attr('id').charAt($(e).attr('id').length - 1));
        if (data.phones[phoneOrder]) {
          data.phones[phoneOrder].typeCode = mapPhoneTypeCode(e.value);
        }
      }
      if ($(e).attr('id') === 'isoDateOfBirth') {
        if (e.value && new Date(e.value) != 'Invalid Date') {
          data.birthDate = e.value;
        } else if (data.birthDate) {
          delete data.birthDate;
        }
      }
      if ($(e).attr('id') === 'emailAddress' && e.value) {
        if (!data.emails) {
          data.emails = [{
            'DefaultInd': true,
            'email': e.value,
            'order': 1
          }];
        } else if (data.emails.length == 0) {
          data.emails.push({
            'DefaultInd': true,
            'email': e.value,
            'order': 1
          });
        } else if (data.emails[0].email != e.value) {
          data.updateEmail = true;
          data.emails[0].email = e.value;
        }
      }

      if (typeof data.addresses[0] === 'object') {
        switch ($(e).attr('id')) {
        case 'addressType0':
          data.addresses[0].order = parseFloat(e.value);
          data.addresses[0].typeCode = (parseFloat(e.value) == 1) ? 'Home' : 'Business';
          data.updateAddress = true;
          break;
        case 'address1-0':
          if (e.value && !_.isEqual(data.addresses[0].address1, e.value)) {
            data.updateAddress = true;
            data.addresses[0].address1 = e.value;
          }
          break;
        case 'address2-0':
          if (e.value && !_.isEqual(data.addresses[0].address2, e.value)) {
            data.updateAddress = true;
            data.addresses[0].address2 = e.value;
          }
          break;
        case 'address3-0':
          if (e.value && !_.isEqual(data.addresses[0].address3, e.value)) {
            data.updateAddress = true;
            data.addresses[0].address3 = e.value;
          }
          break;
        case 'city0':
          if (e.value && !_.isEqual(data.addresses[0].city, e.value)) {
            data.updateAddress = true;
            data.addresses[0].city = e.value;
          }
          break;
        case 'state0':
          if (e.value) {
            if (!_.isEqual(data.addresses[0].stateCode, Form.removeStatePrefix(e.value))) {
              data.updateAddress = true;
              data.addresses[0].stateCode = Form.removeStatePrefix(e.value);
            }
          }
          break;
        case 'country0':
          if (e.value && !_.isEqual(data.addresses[0].countryCode, e.value)) {
            data.updateAddress = true;
            data.addresses[0].countryCode = e.value;
          }
          break;
        case 'zipCode0':
          if (e.value && !_.isEqual(data.addresses[0].zip, e.value)) {
            data.updateAddress = true;
            data.addresses[0].zip = e.value;
          }
          break;
        default:
          break;
        }
      }
      if (typeof data.addresses[1] === 'object') {
        switch ($(e).attr('id')) {
        case 'addressType1':
          data.addresses[1].order = parseFloat(e.value);
          data.addresses[1].typeCode = (parseFloat(e.value) == 1) ? 'Home' : 'Business';
          data.updateAddress = true;
          break;
        case 'address1-1':
          if (e.value && !_.isEqual(data.addresses[1].address1, e.value)) {
            data.updateAddress = true;
            data.addresses[1].address1 = e.value;
          }
          break;
        case 'address2-1':
          if (e.value && !_.isEqual(data.addresses[1].address2, e.value)) {
            data.updateAddress = true;
            data.addresses[1].address2 = e.value;
          }
          break;
        case 'address3-1':
          if (e.value && !_.isEqual(data.addresses[1].address3, e.value)) {
            data.updateAddress = true;
            data.addresses[1].address3 = e.value;
          }
          break;
        case 'city1':
          if (e.value && !_.isEqual(data.addresses[1].city, e.value)) {
            data.updateAddress = true;
            data.addresses[1].city = e.value;
          }
          break;
        case 'state1':
          if (e.value) {
            if (!_.isEqual(data.addresses[1].stateCode, Form.removeStatePrefix(e.value))) {
              data.updateAddress = true;
              data.addresses[1].stateCode = Form.removeStatePrefix(e.value);
            }
          }
          break;
        case 'country1':
          if (e.value && !_.isEqual(data.addresses[1].countryCode, e.value)) {
            data.updateAddress = true;
            data.addresses[1].countryCode = e.value;
          }
          break;
        case 'zipCode1':
          if (e.value && !_.isEqual(data.addresses[1].zip, e.value)) {
            data.updateAddress = true;
            data.addresses[1].zip = e.value;
          }
          break;
        default:
          break;
        }
      }
    });

    data.addresses = Form.reindexAddressBasedOnCountry(data.addresses);
    if (data.preferences && $("#businessEnrollmentCheckbox").is(":checked")) {
      const businessPreference = $('#businessEnrollmentSelect').val();
      const i = data.preferences.findIndex(preference => preference.preferenceRuleCode === 'BUSTRAV');
      if (i && data.preferences[i] && businessPreference) {
        data.preferences[i] = {
          ...data.preferences[i],
          value: mapBusinessTravelerType(businessPreference)
        };
      }
    } else {
      const businessPreference = $('#businessEnrollmentSelect').val();
      const i = data.preferences.findIndex(preference => preference.preferenceRuleCode === 'BUSTRAV');
      if (i && data.preferences[i] && businessPreference) {
        data.preferences[i] = {
          ...data.preferences[i],
          value: ''
        };
      }
    }
    data.updatePreferences = true;
    return data;
  }

  postForm(data) {
    const newEmail = data.emails && data.emails[0].email;
    const emailChanged = this.email !== newEmail;
    data = JSON.stringify(data);
    Spinner.appendTo(this.$form);
    Form.disableFormField(this.$form.find('.submit'));
    Form.disableFormField(this.$form.find('.cancel'));
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: requestUrls['update'],
      data,
      context: {
        onFail: {
          formElement: this.$form,
          scrollToElement: this.$form
        }
      },
      success: (response) => {
        this.triggerBusinessEnrollmentAnalytics();
        Spinner.remove(this.$form);
        Form.showSuccessMessage(this.$form, 'update');
        // Form.reset($('#profileUpdate'));
        UserHandler.getProfile(() => {
          Form.disableFormField(this.$form.find('.submit'));
        });
        if (emailChanged) {
          this.email = newEmail;
          $('.verify-email, .verificationMessage, .resendEmail').each(function() {
            $(this).removeClass('hidden');
          });
        }
        [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
          emailMessage.addClass('hidden');
        });
        localStorage.setItem('EMAIL_SENT_NOT_VERIFY', true);
      },
      error: (errRes) => {
        console.error('update error: ' + JSON.stringify(errRes));
        console.trace({errRes});
        if (errRes.status == 403 || errRes.status == 401) {
          console.error('calling redirectToOktaLogin');
          //localStorage.clear();
          //sessionStorage.clear();
          //CookieHandler.readCookie(WR_AUTHENTICATED) === 'true'
          //Login.callSignOutAPI(window.location.href);
          SessionUserHandler.logout();
          Login.redirectToOktaLogin();
        }
      },
      complete: () => {
        Form.enableFormField(this.$form.find('.cancel'));
      }
    });
  }

  triggerBusinessEnrollmentAnalytics() {
    if (this.$beCheckbox.is(':checked')) {
      let $optionSelected = this.$beSelect.find('option:selected');
      let customerType = $optionSelected.data('originalText') || $optionSelected.text();
      if (customerType && window.digitalData && window.digitalData.page  && window.digitalData.page.pageInfo) {
        window.digitalData.page.pageInfo.customerType = customerType;
        if (typeof window._satellite !== 'undefined') {
          window._satellite.track('businessTravelerView');
        }
      }
    }
  }

  initResendEmail() {
    setTimeout(() => {
      const verifyEmailContainer = $('.verify-email'),
        resendCode = $('.resendCode'),
        resendEmail = $('.resendEmail'),
        spinner = verifyEmailContainer.find('.email-spinner-container');
      const user = SessionUserHandler.getOktaUser();
      if (user) {
        const isEmailVerified = this.emailVerified; // user.email_verified;
        $(".resendCode").removeAttr("href").css("cursor","pointer");
        $(".resendEmail").removeAttr("href").css("cursor","pointer");
        if (!isEmailVerified) {
          spinner.show();
          verifyEmailContainer.removeClass('hidden');
          [resendCode, resendEmail].forEach(resendLink => {
            resendLink.on('click', (e) => {
              e.preventDefault();
              this.verifyEmail(user.sub);
            });
          });
          spinner.hide();
        }
      }
    }, this.emailVerified === undefined ? 1000 : 0);
  }

  verifyEmail(oktaIdentifier) {
    [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
      emailMessage.addClass('hidden');
    });
    [$('.verificationMessage'), $('.resendEmail')].forEach(emailMessage => {
      emailMessage.removeClass('hidden');
    });
    localStorage.setItem('EMAIL_SENT_NOT_VERIFY', false);
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: requestUrls['verifyEmail'],
      data: JSON.stringify({oktaIdentifier}),
      success: (response) => {
        // Form.reset($('#profileUpdate'));
        [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
          emailMessage.addClass('hidden');
        });
        [$('.verificationMessage'), $('.resendEmail')].forEach(emailMessage => {
          emailMessage.removeClass('hidden');
        });
        localStorage.setItem('EMAIL_SENT_NOT_VERIFY', true);
      },
      error: (err) => {
        [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
          emailMessage.removeClass('hidden');
        });
        [$('.verificationMessage'), $('.resendEmail')].forEach(emailMessage => {
          emailMessage.addClass('hidden');
        });
      }
    });
  }

  updateEmail(email) {
    [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
      emailMessage.addClass('hidden');
    });
    [$('.verificationMessage'), $('.resendEmail')].forEach(emailMessage => {
      emailMessage.addClass('hidden');
    });
    var label = $("label[for='emailAddress']");
    $('#email-error-message').css('display', 'none');
    label.css('color', '#666666');
    localStorage.setItem('EMAIL_SENT_NOT_VERIFY', false);

    const emails = window.User.emails;
    const data = {
      updateCustomer: false,
      updateAddress: false,
      updateAlias: false,
      updatePreferences: false,
      updateEmail: true,
      memberIdentifier: window.User.accountNumber,
      emails: [{
        ...emails[0],
        email
      }]
    };
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: requestUrls['update'],
      data: JSON.stringify(data),
      success: (response) => {
        // Form.reset($('#profileUpdate'));
        [$('.verify-email')].forEach(emailMessage => {
          emailMessage.removeClass('hidden');
        });
        [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
          emailMessage.addClass('hidden');
        });
        [$('.verificationMessage'), $('.resendEmail')].forEach(emailMessage => {
          emailMessage.removeClass('hidden');
        });
        SessionUserHandler.setOktaUserEmail(email);
        localStorage.setItem('EMAIL_SENT_NOT_VERIFY', true);
      },
      error: (errResponse) => {
        const err = getJsonObject(errResponse);
        var label = $("label[for='emailAddress']");
        if (err && err.responseJSON && err.responseJSON.ErrorMessage){
          $('#email-error-message').css('display', 'block');
          label.css('color', '#ff2424');
          $('#email-error-message').html(DOMPurify.sanitize(err.responseJSON.ErrorMessage));
          $('.notification-banner').css('display', 'none');
          $('.notification-banner').remove();
        }
        [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
          emailMessage.removeClass('hidden');
        });
        [$('.verificationMessage'), $('.resendEmail')].forEach(emailMessage => {
          emailMessage.addClass('hidden');
        });
        localStorage.setItem('EMAIL_SENT_NOT_VERIFY', false);
      },
      complete: (resultData) => {
        const result = getJsonObject(resultData);
        if (result && result.responseJSON && result.responseJSON.ErrorMessage){
          $('#email-error-message').css('display', 'block');
          $('#email-error-message').html(DOMPurify.sanitize(result.responseJSON.ErrorMessage));
          $('.notification-banner').css('display', 'none');
          $('.notification-banner').remove();
        }
      }
    });
  }

  isValidPassword() {
    const currentPasswordField = $('input#currentPassword');
    const passwordField = $('input#password');
    const passwordMatches = passwordField.val() === $('#confirmPassword').val();
    return isValidOktaPassword(passwordField.val()) && passwordMatches && (currentPasswordField.val() != '');
  }

  showPasswordRequirements() {
    const currentPasswordField = $('input#currentPassword'),
      passwordConditions = $('.password-conditions'),
      passwordField = $('input#password'),
      confirmPasswordField = $($('#confirmPassword')),
      showConditions = passwordConditions.data('showconditions');

    if (showConditions) {
      passwordConditions.removeClass('hidden');
    }

    passwordField.on('focus', () => {
      passwordConditions.removeClass('hidden');
    });
    passwordField.on('focusout', () => {
      if (!showConditions) {
        passwordConditions.addClass('hidden');
      }
    });

    passwordField.on('input', () => {
      const hasSpecialCharacters = passwordField.val().match(/^(?=.*[!@#$%^&]).*$/);
      const hasUppercase = passwordField.val().match(/^(?=.*[A-Z]).*$/);
      const hasLowercase = passwordField.val().match(/^(?=.*[a-z]).*$/);
      const hasNumber = passwordField.val().match(/^(?=.*[0-9]).*$/);
      const hasCharacters =  passwordField.val().length >= 8;
      const hasThreeRequirements = [hasUppercase, hasLowercase, hasNumber, hasSpecialCharacters].filter((value) => value).length >= 3;

      this.toggleCondition($('#validate-characters'), hasCharacters);
      this.toggleCondition($('#validate-three'), hasThreeRequirements);
      this.toggleCondition($('#validate-low'), hasLowercase);
      this.toggleCondition($('#validate-up'), hasUppercase);
      this.toggleCondition($('#validate-num'), hasNumber);
      this.toggleCondition($('#validate-special'), hasSpecialCharacters);
    });

    currentPasswordField.on('blur', () => {
      this.toggleUpdatePasswordButton();
    });
    passwordField.on('blur', () => {
      this.toggleUpdatePasswordButton();
    });
    confirmPasswordField.on('blur', () => {
      this.toggleUpdatePasswordButton();
    });
  }

  toggleUpdatePasswordButton() {
    if (exists($('.password-conditions'))) {
      const submitPasswordButton = $('.password-conditions').parent().siblings('.submit');
      if (submitPasswordButton) {
        submitPasswordButton.prop('disabled', !this.isValidPassword() ? 'disabled' : '');
      }
    }
  }

  toggleCondition(condition, isCorrect) {
    const checkmark = condition.find('.wr-icon-check');
    isCorrect ? checkmark.addClass('green-check') : checkmark.removeClass('green-check');
  }

  initPasswordMatcher() {
    const newPassword = $('#password');
    const confirmNewPassword = $('#confirmPassword');
    const onChange = () => {
      this.toggleErrorMessage(
        newPassword.val(),
        confirmNewPassword.val()
      );
    };
    newPassword.on('input', onChange);
    confirmNewPassword.on('input', onChange);

    this.initUpdatePassword();
  }

  toggleErrorMessage(pass, confirmPass) {
    const formLabel = $('label[for=confirmPassword]');
    const errorMessage = $('#confirm-error-message');

    if (pass !== confirmPass) {
      formLabel.parent().addClass('has-error');
      errorMessage.removeClass('hidden');
    } else {
      formLabel.parent().removeClass('has-error');
      errorMessage.addClass('hidden');
    }

    this.toggleUpdatePasswordButton();
  }

  initUpdatePassword() {
    if (exists($('.password-conditions'))) {
      const submitPasswordButton = $('.password-conditions').parent().siblings('.submit');
      submitPasswordButton.on('click', e => {
        e.preventDefault();
        Spinner.appendTo(this.$form);
        const currentPasswordField = $('input#currentPassword'),
          passwordField = $('input#password');
        let user = SessionUserHandler.getOktaUser();
        const ftsiInfo = getLocalStorage(FTSI);
        if (!user && !ftsiInfo) {
          if (ftsiInfo) {
            user = {
              ...ftsiInfo,
              sub: ftsiInfo.oktaId,
              email: ftsiInfo.emails[0].email
            };
          } else {
            return;
          }
        }

        const data = {
          oktaIdentifier: user.sub,
          email: user.email ? user.email : $('#emailAddress').val(),
          currentPassword: currentPasswordField.val(),
          newPassword: passwordField.val()
        };
        $.ajax({
          type: 'POST',
          contentType: 'application/json',
          url: requestUrls['updateProfile'],
          data: JSON.stringify(data),
          context: {
            onFail: {
              formElement: this.$form,
              scrollToElement: this.$form
            }
          },
          success: (response) => {
            $('.notification-banner').remove();
            Spinner.remove(this.$form);
            Form.showSuccessMessage(this.$form, 'updatePassword');
            Form.reset($('#profileUpdate'));
            this.$form.find('.phone-group .locked-phone-input').removeClass('has-error');
            this.initUsername();
            UserHandler.getProfile(() => {
              Form.disableFormField(this.$form.find('.submit'));
            });
          },
          error: (errResp) => {
            const errRes = getJsonObject(errResp);
            console.error('update error: ' + errRes);
            if (errRes && errRes.responseJSON && errRes.responseJSON.ErrorMessage){
              $('#profile-error-message').html(DOMPurify.sanitize(errRes.responseJSON.ErrorMessage));
            }
          },
          complete: () => {
            Form.enableFormField(this.$form.find('.cancel'));
          }
        });
      });
    }
  }

  initUsername() {
    const oktaUser = SessionUserHandler.getOktaUser();
    let oktaIdentifier = null;
    if (oktaUser) {
      oktaIdentifier = oktaUser.sub;
    } else if (getSessionStorage(OKTA_ID)) {
      oktaIdentifier = getSessionStorage(OKTA_ID).oktaId;
    } else {
      return;
    }
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: requestUrls['onlineProfile'],
      data: JSON.stringify({oktaIdentifier}),
      context: {
        onFail: {
          formElement: this.$form,
          scrollToElement: this.$form
        }
      },
      success: (res) => {
        if (res.success) {
          this.emailVerified = res.emailVerified;
          $('.verify-email .email-spinner-container').hide();
          const usernameFields = $('.username'),
            usernameInput = $('#username');

          if (res.userMetadata) {
            if (res.userMetadata.userName == res.username) {
              usernameFields.removeClass('hidden');
              usernameInput.val(res.username);
              usernameInput.trigger('change');
              const user = SessionUserHandler.getOktaUser();
              const newUserName = $('#emailAddress').val() || user.email;
              this.initUpdateUsernameLink(oktaUser.sub, newUserName);
            }
          }

          if (res.emailVerified == false) {
            let emailSentCheck = localStorage.getItem('EMAIL_SENT_NOT_VERIFY');
            if (emailSentCheck == 'true') {
              [$('.verify-email')].forEach(emailMessage => {
                emailMessage.removeClass('hidden');
              });
              [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
                emailMessage.addClass('hidden');
              });
              [$('.verificationMessage'), $('.resendEmail')].forEach(emailMessage => {
                emailMessage.removeClass('hidden');
              });
            } else {
             [$('.verify-email')].forEach(emailMessage => {
                emailMessage.removeClass('hidden');
              });
              [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
                emailMessage.removeClass('hidden');
              });
              [$('.verificationMessage'), $('.resendEmail')].forEach(emailMessage => {
                emailMessage.addClass('hidden');
              });
            }
          } else {
            [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
              emailMessage.addClass('hidden');
            });
            [$('.verificationMessage'), $('.resendEmail')].forEach(emailMessage => {
              emailMessage.addClass('hidden');
            });
            [$('.verify-email')].forEach(emailMessage => {
              emailMessage.addClass('hidden');
            });
          }
          $('form#profileUpdate .submit:last').attr('disabled', true);
        }
      },
      error: (errRes) => {
        console.error('update error: ' + JSON.stringify(errRes));
        $('.verify-email .email-spinner-container').hide();
        let emailSentCheck = localStorage.getItem('EMAIL_SENT_NOT_VERIFY');
        if (emailSentCheck == 'true') {
          [$('.verify-email')].forEach(emailMessage => {
            emailMessage.removeClass('hidden');
          });
          [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
            emailMessage.addClass('hidden');
          });
          [$('.verificationMessage'), $('.resendEmail')].forEach(emailMessage => {
            emailMessage.removeClass('hidden');
          });
        } else {
          [$('.verify-email')].forEach(emailMessage => {
            emailMessage.removeClass('hidden');
          });
          [$('.notVerifiedEmailMessage'), $('.resendCode')].forEach(emailMessage => {
            emailMessage.removeClass('hidden');
          });
          [$('.verificationMessage'), $('.resendEmail')].forEach(emailMessage => {
            emailMessage.addClass('hidden');
          });
        }
      },
    });
  }

  initUpdateUsernameLink(oktaId, email) {
    const updateUsernameLink = $('.useEmailAsUsername');
    if (!email) {
      updateUsernameLink.hide();
      return;
    }
    updateUsernameLink.on('click', () => {
      Spinner.appendTo(this.$form);
      const data = {
        oktaIdentifier: oktaId,
        username: email + '.' //. is added as okta doesn't accept email format as username
      };
      $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: requestUrls['updateProfile'],
        data: JSON.stringify(data),
        context: {
          onFail: {
            formElement: this.$form,
            scrollToElement: this.$form
          }
        },
        success: (res) => {
          Spinner.remove(this.$form);
          $('.username-input').addClass('hidden');
          $('.email-username').addClass('hidden');
          $('.user-successful-message').removeClass('hidden');
          Form.reset($('#profileUpdate'));
          this.$form.find('.phone-group .locked-phone-input').removeClass('has-error');
          UserHandler.getProfile(() => {
            Form.disableFormField(this.$form.find('.submit'));
          });
        }
      });
    });
  }

  initViewPassword() {
    const  currentPasswordInput = $('#currentPassword'),
      passwordInput = $('#password'),
      confirmPasswordInput = $('#confirmPassword'),
      currentPasswordEye = currentPasswordInput.siblings('.eye'),
      currentPasswordDashEye = currentPasswordInput.siblings('.dash-eye'),
      passwordEye = passwordInput.siblings('.eye'),
      passwordDashEye = passwordInput.siblings('.dash-eye'),
      confirmPasswordEye = confirmPasswordInput.siblings('.eye'),
      confirmPasswordDashEye = confirmPasswordInput.siblings('.dash-eye');

    this.addToggleViewEventListener(currentPasswordInput, currentPasswordEye, currentPasswordDashEye);
    this.addToggleViewEventListener(passwordInput, passwordEye, passwordDashEye);
    this.addToggleViewEventListener(confirmPasswordInput, confirmPasswordEye, confirmPasswordDashEye);
  }

  addToggleViewEventListener(input, eye, dashEye) {
    eye.on('click', () => {
      input.attr('type', 'text');
      eye.addClass('hidden');
      dashEye.removeClass('hidden');
    });
    dashEye.on('click', () => {
      input.attr('type', 'password');
      eye.removeClass('hidden');
      dashEye.addClass('hidden');
    });
  }
}

export default new MyProfileForm();
